export const MuiListItemTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                position: "relative",
                columnGap: dt.inline.medium,
                paddingRight: 0,
                paddingLeft: 0,
                "&.Mui-selected": {
                    background: dt.cta.outlined.color.background.primary.active,
                    "&.Mui-disabled": {
                        background: dt.cta.contained.color.background.primary.disabled,
                    },
                },
            },
            dense: {
                paddingTop: dt.stacked.xSmall,
                paddingBottom: dt.stacked.xSmall,
            },
            gutters: {
                paddingLeft: dt.inset.squish.medium.horizontal,
                paddingRight: dt.inset.squish.medium.horizontal,
            },
            padding: {
                paddingTop: `calc(${dt.stacked.xSmall} + ${dt.space.inline.xSmall4})`,
                paddingBottom: `calc(${dt.stacked.xSmall} + ${dt.space.inline.xSmall4})`,
            },
        },
    };
};
